import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Spray_sealing_of_ground_walls() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>      איטום קירות תת קרקעים בהתזה / יריעות ביטומניות</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Spray_sealing_of_ground_walls">   איטום קירות תת קרקעים בהתזה / יריעות ביטומניות</Link>{" "}
</div>
    </div>
    <div className="video-line" />


      {/* CONTENT */}
<div className="page6">
  <div className="container">

    <div className="content-row2">

     <div className="image-box2">
        <img src="/images/71.jpg" alt="roof" />
      </div>
 
      <div className="text-box">
          <h2 className="info-title"> בשעה טובה אנו בונים בית חדש!


</h2>
        <p>  
איטום הקירות והשטח התת קרקעיים הוא אחד השלבים החשובים ביותר אם לא החשוב ביותר בבניית הבית.

</p>

       <p>  
</p>



       <p>  
יש לשים דגש שהאיטום מתבצע ע"י חומרים המתאימים לכך.
</p>

       <p>  
אנו משתמשים במערכת איטום דו שכבתית של יריעות ביטומניות SBS נגד שורשים או איטום בהתזה של REMMERS
</p>

       <p>  
(קיימים עוד מספר רב של אופציות נכונות וטובות לאיטום)
</p>
       <p>  
לאחר איטום קירות המרתף תמיד יש לבצע שכבת הגנה של יריעות ביצים או קלקר F30 . 

</p>


      </div>

    </div>
    <ContactSection2/>
<div className="links2">


  <Link to="/Roof_tar_and_plastering" className="link-right" >   זיפות וסיוד גגות </Link>
  <Link to="/Sealing_Wet_Rooms" className="link-left" >   איטום חדרים רטובים </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


